// verbiage
export const REQUIRED_ERROR = 'Please fill in the required fields.'
export const TOPIC_HINT_VERBIAGE = 'Click on a topic to reveal any notes associated with that topic.'
